import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
 import "./WelcomeName.css";

const WelcomeName = () => {
    const { instance } = useMsal();
    const [name, setName] = useState(null);

    const activeAccount = instance.getActiveAccount();
    
    useEffect(() => {
    
         if (activeAccount) {
            setName(activeAccount.name);
        } else {
            setName(null);
        }
    }, [activeAccount]);

    if (name) {
        
        return <span className="userName" tabIndex={0} >Hello, {name}! </span>;
    } else {
        return null;
    }
};

export default WelcomeName;